<template>
  <div class="lance-manual-keyboard">
    <u-btn label="Lançar manualmente" no-caps @click="digitarLance" v-shortkey="['f10']"
                             @shortkey.native="digitarLance" class="hide" />

    <!-- DIALOG -->
    <u-dialog
        v-model="digitarLanceDialog"
        @cancel="digitarLanceCancel"
        @ok="digitarLanceConfirm"
    >
      <span slot="title">Alterar Lance Inicial</span>

      <!--<span slot="message">What is your superhero of choice?</span>-->

      <div slot="body">
        <u-field
            icon="attach_money"
            label="Lance Inicial:"
            :label-width="3"
            helper="Evite utilizar casas decimais"
        >
          <u-input ref="defInput" autofocus v-model="digitarLanceValor" @keydown.prevent.enter="digitarLanceConfirm" class="no-shortkey" v-money="money" />
        </u-field>
      </div>

      <template slot="buttons" slot-scope="props">
        <u-btn flat label="Cancelar" @click="props.cancel" />
        <u-btn color="primary" label="Confirmar alteração" @click="props.ok" />
      </template>
    </u-dialog>
  </div>
</template>

<script>
import {UDialog, UField, UInput} from 'uloc-vue'
import {VMoney} from 'v-money'
import {REAL_BRL, convertRealToMoney} from '@/utils/money'

export default {
  name: 'LanceInicial',
  components: {UDialog, UInput, UField},
  directives: {money: VMoney},
  data () {
    return {
      money: REAL_BRL,
      digitarLanceDialog: false,
      digitarLanceValor: null,
    }
  },
  methods: {
    digitarLance () {
      // this.resetAlteracaoLance()
      this.digitarLanceDialog = true
      window.setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.defInput.focus()
        })
      }, 400)
    },
    digitarLanceConfirm () {
      //this.$emit('lanceInicial', Number(String(this.digitarLanceValor).replace(/\D/gi, '')))
      this.$emit('lanceInicial', convertRealToMoney(this.digitarLanceValor))
      this.resetAlteracaoLance()
    },
    digitarLanceCancel () {
      this.resetAlteracaoLance()
    },
    resetAlteracaoLance () {
      this.digitarLanceDialog = false
      this.digitarLanceValor = null
    }
  }
}
</script>
